import { render, staticRenderFns } from "./aboutBrief.vue?vue&type=template&id=6d46b9af&scoped=true"
import script from "./aboutBrief.vue?vue&type=script&lang=js"
export * from "./aboutBrief.vue?vue&type=script&lang=js"
import style0 from "./aboutBrief.vue?vue&type=style&index=0&id=6d46b9af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d46b9af",
  null
  
)

export default component.exports